
import { IChartDataPerMonthPerYear } from "@/utils/chart-income";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import Vue from "vue";
import AppPurchaseChart from "./PurchaseChart.vue";
import { DashboardRevenuePerMonthCompareData } from "@/utils/dashboard/dashboard-revenue-per-month-compare-data";
import {ChartService} from "@/services";

export default Vue.extend({
	data(){
		return {
			income: null as null | IChartDataPerMonthPerYear
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		maxToShowYears():number{
			return this.data.ToShowYears || 1;
		},
		data():DashboardRevenuePerMonthCompareData{
			return this.item.Data as DashboardRevenuePerMonthCompareData;
		}
	},
	methods: {
		async fetch(){
			this.income = await ChartService.getExpense(this.maxToShowYears, this.data.filters);
		}
	},
	mounted(){
		this.fetch();
	},
	components: {
		AppPurchaseChart
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
